import _ from 'lodash'
import { Map, List } from 'immutable'

import { doProcessRules } from '../../../lib/processPortalRules'
import * as actionTypes from '../actionTypes'

export const processTextReviewInteractivityAction = (entry, getState, dispatch) => {
  let state = getState()

  const elementStatePath = entry.getIn(['payload', 'path'], List()).toJS()
  const elementState = entry.getIn(['payload', 'state'], Map())

  state = state.setIn(elementStatePath, elementState)

  state = doProcessRules(
    state,
    false,
    null,
    [],
    [_.tail(elementStatePath)],
    false,
    false,
    state.get('prevRulesState', Map()).toJS()
  )

  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: state,
    },
  })
}
